export default __webpack_public_path__ + "static/media/luftansa.cae0c65d.jpg";